const PAGE_FILENAME_CHARACTER_WHITELIST = /^[A-Za-z0-9 _\-(),.]*$/

export function isPageFilenameValid(filename: string | null): boolean {
  if (!filename) return false

  const trimmed = filename.trim()

  return trimmed.length > 0
    && trimmed.length <= 255
    && trimmed.endsWith('.svg')
    && PAGE_FILENAME_CHARACTER_WHITELIST.test(trimmed)
}
